export const recurrenceTypes = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  NONE: 'NONE'
};

export const daysOfWeek = {
  MON: 'MON',
  TUE: 'TUE',
  WED: 'WED',
  THU: 'THU',
  FRI: 'FRI',
  SAT: 'SAT',
  SUN: 'SUN'
};

export const daysOfWeekOrder = {
  MON: 0,
  TUE: 1,
  WED: 2,
  THU: 3,
  FRI: 4,
  SAT: 5,
  SUN: 6
};

export const monthlyOptionsTypes = {
  ON_DAY: 'ON_DAY',
  LAST_DAY: 'LAST_DAY',
  DAYS_BEFORE_END: 'DAYS_BEFORE_END'
};
